/**
 * GA4 loader — no-ops until REACT_APP_GA_MEASUREMENT_ID is set (Vercel/GitHub Secret
 * PROD_ENCODED_ENV_FE), so nothing loads or fires in dev/local builds without a real ID.
 * Call initAnalytics() once at app boot, then trackPageview(path) on every route change —
 * this is an SPA, so GA's own automatic pageview-on-load only ever sees the first URL.
 */
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export function initAnalytics() {
	if (!GA_ID || initialized) return;
	initialized = true;

	const script = document.createElement('script');
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
	document.head.appendChild(script);

	window.dataLayer = window.dataLayer || [];
	function gtag() { window.dataLayer.push(arguments); }
	window.gtag = gtag;
	gtag('js', new Date());
	// send_page_view: false — we send pageviews ourselves via trackPageview() on route change.
	gtag('config', GA_ID, { send_page_view: false });
}

export function trackPageview(path) {
	if (!GA_ID || typeof window.gtag !== 'function') return;
	window.gtag('event', 'page_view', { page_path: path });
}
